import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export default function useOCREngines(enabled = true) {
  const glynt = useGlynt();

  const { data, isPending, isError } = useQuery({
    queryKey: ['tokenizerVersions'],
    queryFn: async () => (await glynt).tokenizer.versions(),
    enabled,
  });

  const versions = {
    active: data?.active
      .filter((el) => !data?.deprecated.includes(el))
      .sort()
      .reverse() as string[],
    experimental: data?.experimental.sort().reverse() as string[],
  };

  return { data: versions, isPending, isLoading: isPending, isError };
}
